var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartyHorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6166 3.87231C8.40579 3.65026 8.40579 3.29025 8.6166 3.0682L9.47261 2.16654C9.68342 1.94449 10.0252 1.94449 10.236 2.16654L11.092 3.0682C11.3028 3.29025 11.3028 3.65026 11.092 3.87231L10.236 4.77397C10.0252 4.99602 9.68342 4.99602 9.47261 4.77397L8.6166 3.87231Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4912 7.4504C19.3856 7.4504 20.1107 6.6867 20.1107 5.74462C20.1107 4.80255 19.3856 4.03885 18.4912 4.03885C17.5969 4.03885 16.8718 4.80255 16.8718 5.74462C16.8718 6.6867 17.5969 7.4504 18.4912 7.4504Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56888 9.56323C9.12656 12.0214 11.3773 14.8246 13.2594 17.9069L15.3249 17.1299C16.0561 16.8548 16.2808 15.8809 15.751 15.283L8.96322 7.62262C8.4234 7.01341 7.46539 7.20247 7.17156 7.9762L6.56888 9.56323Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1684 18.6935L8.46033 19.7122C7.2412 18.0652 5.90853 16.5171 4.47385 15.08L5.70883 11.828C7.76285 13.8889 9.59537 16.191 11.1684 18.6935Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.312 20.5204C5.46357 19.4178 4.56038 18.3643 3.60647 17.3641L2.02394 21.5314C1.92033 21.8042 2.17086 22.0782 2.43359 21.9794L6.312 20.5204Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6177 12.602C19.3018 11.2159 17.5159 11.4675 16.1262 12.1302C15.7188 12.3245 15.239 12.1341 15.0546 11.705C14.8701 11.2759 15.0509 10.7705 15.4582 10.5763C17.0644 9.81031 19.7222 9.24634 21.7628 11.3958C22.0791 11.7289 22.0791 12.2689 21.7628 12.602C21.4466 12.935 20.9339 12.935 20.6177 12.602Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5223 2.90165C15.5223 2.43062 15.1598 2.04877 14.7126 2.04877C14.2654 2.04877 13.9029 2.43062 13.9029 2.90165C13.9029 3.69238 13.5191 5.62138 12.0675 6.76807C11.7098 7.05069 11.6373 7.58528 11.9056 7.96211C12.1739 8.33893 12.6814 8.4153 13.0392 8.13268C15.0424 6.55014 15.5223 4.00623 15.5223 2.90165Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.825 7.98449C16.1412 8.31756 16.1412 8.85758 15.825 9.19065L14.7453 10.3278C14.4291 10.6609 13.9164 10.6609 13.6002 10.3278C13.284 9.99476 13.284 9.45474 13.6002 9.12167L14.6798 7.98449C14.9961 7.65141 15.5087 7.65141 15.825 7.98449Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0311 15.4107C19.6273 15.4107 20.1107 14.9015 20.1107 14.2735C20.1107 13.6454 19.6273 13.1363 19.0311 13.1363C18.4348 13.1363 17.9514 13.6454 17.9514 14.2735C17.9514 14.9015 18.4348 15.4107 19.0311 15.4107Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyHorn);
export default __webpack_public_path__ + "static/media/party-horn.9e1af85c7d9cc7b249fdc825c1441386.svg";
export { ForwardRef as ReactComponent };